import { useEffect as w } from "react";
const a = _ref => {
  let {
    openSubMenu: e,
    setOpenSubMenu: r,
    menuButton: t,
    profileButton: o,
    wrapperRef: i,
    overlay: u
  } = _ref;
  w(() => {
    const l = d => {
      var s;
      const c = window.document.body.clientWidth > 840,
        n = d.target;
      (e && c && !((s = i.current) != null && s.contains(n)) && !(t != null && t.contains(n)) && !(o != null && o.contains(n)) || e && u != null && u.contains(n)) && r(!1);
    };
    return window.addEventListener("mousedown", l), () => {
      window.removeEventListener("mousedown", l);
    };
  }, [t, e, o, r, i, u]);
};
export { a as useClickOutsideOverflow };